import {
	addHotel,
	contains,
	onChangeHotels,
	removeHotels,
} from "../state/FavoriteHotels";
import { html, nothing, render } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { translate } from "../../shared/l10n/translate";
import { stateful } from "@escapio/shared/components/element-builder";
import * as facebook from "../tracker/Facebook";
import * as Tracker from "../tracker/EventTracker";
import { pageType } from "@escapio/portal/state/pageType.js";

const trackingOriginMapping = {
	article: "Liste",
	hotel: "Hotel",
	favorites: "Merkliste",
	deals: "Deals",
	home: "Home",
};
const TRACKING_CATEGORY = trackingOriginMapping[pageType];

customElements.define(
	"esc-hotel-favorite-status",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					isFavorite: false,
				};
			}

			connectedCallback() {
				this.hotelId = parseInt(this.getAttribute("hotel-id"));
				this.hotelName = this.getAttribute("hotel-name");
				this.isFavorite = contains(this.hotelId);

				onChangeHotels(() => {
					const newState = contains(this.hotelId);
					if (this.isFavorite !== newState) {
						this.isFavorite = newState;
					}
				});
			}

			render() {
				const label = this.isFavorite
					? translate("hotel_at_my_wishlist")
					: translate("hotel_add_to_wishlist");
				const template = html` <button
					@click=${this.toggleStatus}
					aria-label="${label}"
				>
					<span
						class="hotel-favorite__icon fa fa-heart-o ${classMap({
							"hotel-favorite__icon--active": this.isFavorite,
						})}"
					>
						<span class="fa fa-heart"></span>
					</span>
					${this.hasAttribute("only-icon")
						? nothing
						: html`<span class="hotel-favorite__label">${label}</span>`}
				</button>`;
				render(template, this, { host: this });
			}

			toggleStatus(event) {
				event.preventDefault();
				event.stopPropagation();

				const label = `${this.hotelId} | ${this.hotelName}`;
				if (this.isFavorite) {
					removeHotels([this.hotelId]);
					Tracker.track(
						TRACKING_CATEGORY,
						this.trackAction,
						`${label} - entfernt`,
					);
				} else {
					addHotel(this.hotelId);
					this.dispatchEvent(new CustomEvent("addToFavorites"));
					Tracker.track(
						TRACKING_CATEGORY,
						this.trackAction,
						`${label} - hinzugefügt`,
					);
					facebook.trackAddToWishlist(this.hotelId, this.hotelName);
				}
			}

			get trackAction() {
				return `Merken${this.trackActionSuffix}`;
			}

			get trackActionSuffix() {
				return this.getAttribute("track-action-suffix") || "";
			}
		},
	),
);
